import enAdministration from './en';
import ruAdministration from './ru';

export default {
  en: {
    ...enAdministration,
  },
  ru: {
    ...ruAdministration,
  },
};
